import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  IconNavDashboard,
  IconNavUsers,
  IconNavInventory,
  IconNavSales,
  IconNavFinance,
  IconNavReports,
  IconNavProfile,
  IconNavExpenses,
} from './icons';

interface NavItem {
  name: string;
  path: string;
  icon: React.FC<{ className?: string }>;
}

const adminNavigation: NavItem[] = [
  { name: 'Dashboard', path: '/', icon: IconNavDashboard },
  { name: 'Users', path: '/users', icon: IconNavUsers },
  { name: 'Profile', path: '/profile', icon: IconNavProfile },
];

const clientNavigation: NavItem[] = [
  { name: 'Dashboard', path: '/', icon: IconNavDashboard },
  { name: 'Inventory', path: '/inventory', icon: IconNavInventory },
  { name: 'Sales', path: '/sales', icon: IconNavSales },
  { name: 'Expenses', path: '/expenses', icon: IconNavExpenses },
  { name: 'Finance', path: '/finance', icon: IconNavFinance },
  { name: 'Reports', path: '/reports', icon: IconNavReports },
  { name: 'Moderators', path: '/users', icon: IconNavUsers },
  { name: 'Profile', path: '/profile', icon: IconNavProfile },
];

export const Sidebar: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const navigation = user?.role === 'admin' ? adminNavigation : clientNavigation;

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-gray-800 text-white rounded-lg shadow-lg"
        aria-label="Toggle menu"
      >
        <span className="text-2xl">☰</span>
      </button>

      {/* Sidebar */}
      <aside
        className={`
          w-64 bg-gray-800 text-white min-h-screen fixed lg:static z-40
          transform transition-transform duration-300 ease-in-out
          ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <nav className="p-4">
          <div className="flex items-center justify-between mb-4 lg:hidden">
            <h2 className="text-xl font-bold">Menu</h2>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-300 hover:text-white text-2xl"
              aria-label="Close menu"
            >
              ✕
            </button>
          </div>
          <ul className="space-y-2">
            {navigation.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`
                      flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors
                      ${isActive
                        ? 'bg-blue-600 text-white'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                      }
                    `}
                  >
                    <item.icon className="w-5 h-5" />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>

      {/* Overlay for mobile */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

